module.exports = __webpack_public_path__ + "img/ford.dd22d3c2.svg";